import {
  Box,
  Button,
  Card,
  CardActions,
  Tooltip,
  CardContent,
  CardMedia,
  Chip,
  Divider,
  Stack,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { memo, useState } from "react";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CallIcon from '@mui/icons-material/Call';
import ModalPDF from "../../components/ModalPDF";
import { categorias as catalogoCategorias } from "../../data/dataMedicos";


import CedulaModal from "../../components/CedulaModal";
// import { consultarCedula } from "../../services/CedulaService";
// import { obtenerRecaptcha } from "../../utils/Recaptcha";
import { obtenerTokenSEP, consultarCedula, } from "../../services/CedulaService";
import { obtenerRecaptcha,} from "../../services/recaptchaService";

const CardMedico = ({ contenido }) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [openModal, setOpen] = useState(false);
  const [currentPdf, setCurrentPdf] = useState(null);

  const [openCedula, setOpenCedula] = useState(false);
  const [loadingCedula, setLoadingCedula] = useState(false);
  const [datosCedula, setDatosCedula] = useState(null);

  const handleOpenModal = (encontrarArchivo) => {
    setCurrentPdf(encontrarArchivo);
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const abrirCedula = async (cedulaItem) => {
    try {
      setLoadingCedula(true);
      setOpenCedula(true);
      setDatosCedula(null);

      const token = await obtenerRecaptcha();

      const response = await consultarCedula(
        cedulaItem,
        token
      );

      if (Array.isArray(response) && response.length > 0) {
        setDatosCedula(response[0]);
      } else {
        setDatosCedula(null);
      }

    } catch (error) {
      console.error("Error al consultar cédula:", error);
      setDatosCedula(null);
    } finally {
      setLoadingCedula(false);
    }
  };

  const normalizarCategoria = (texto) => {
    return texto
      ?.normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toLowerCase();
  };

  const categorias = [
    contenido.especialidad,
    contenido.subespecialidad,
  ].filter(Boolean);

  const descripcionesCategorias = Object.fromEntries(
    catalogoCategorias.map((categoria) => [
      normalizarCategoria(categoria.nombre),
      categoria.descripcion,
    ])
  );

  const descripciones = [
    contenido.DGPE,
  ].filter(Boolean);

  const cedulas = [
    contenido.DGPE,
    contenido.CPE,
    contenido.CPE_01,
  ].filter(Boolean);

  return (
    <Grid
      item
      xs={6}
      sm={3}
      md={3}
      lg={3}
      sx={{
        display: "flex",
        justifyContent: "center",
        paddingLeft: "0 !important",
        maxWidth: "100% !important",
        //minWidth: "328px"
      }}
    >
      {/* CONTENEDOR CON PERSPECTIVA */}
      <Box
        sx={{
          perspective: "1200px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Card sx={{
          height: {sm:"600px", md:"570px"},
          width: "100%",
          //maxWidth: "335px",
          display: "flex",
          flexDirection: "column",
          transformStyle: "preserve-3d",
          transition: "transform 0.6s ease, box-shadow 1s ease, opacity 1s ease",
          boxShadow: "0 10px 20px rgba(0,0,0,0.15)",
          overflow: "visible",

          "&:hover": {
            boxShadow: "0 25px 45px rgba(0,0,0,0.35)",
            transform:
            //"perspective(900px) translateY(-5%) rotateX(25deg) translateZ(0)",
            "rotateX(5deg) translateY(-2%)",
          },

          "&:hover::before": {
            opacity: 1,
          },
        }}>

          <Box className="wrapper" sx={{
            width: "100%",
            height: "0%",
          }}>

            {/* IMAGEN */}
            <CardMedia sx={{
              height: 110,
              display: "flex",
              justifyContent: "center",
              paddingTop: "10px",
              opacity: 1,
              transform: "translateZ(20px)",
              transition: "transform 0.6s ease, opacity 1s ease",
            }}>
              <img
                src={contenido.imagen}
                alt={contenido.nombre}
                height="100px"
              />
            </CardMedia>

            {/* NOMBRE */}
            <Typography
              variant="h6"
              textAlign="center"
              sx={{
                mt: 6,
                fontWeight: 700,
                color: "#183153",
                lineHeight: 1.2,
                minHeight: 58,
                maxWidth: "270px",
                placeSelf: "center"
            }}>
              {contenido.nombre}
            </Typography>

            <Divider sx={{ borderStyle: "dashed", borderColor: "#D8D8D8"}}/>

            {/* ESPECIALIDADES */}
            <CardContent sx={{ pt: 2, pb: 2, px: 1, flexGrow: 1}}>
              <Typography
                variant="overline"
                sx={{
                  color: "#06C7F9",
                  fontWeight: 700,
                  letterSpacing: 1.5,
              }}>
                ESPECIALIDADES
              </Typography>

              <Stack
                direction="row"
                spacing={0.5}
                useFlexGap
                flexWrap="wrap"
                mt={1.5}
              >
                {categorias.map((categoria, index) => {
                  const descripcion = descripcionesCategorias[normalizarCategoria(categoria)] || "";
                  // console.log(categoria + descripcion);

                  return (
                    <Tooltip
                      key={index}
                      title={descripcion}
                      arrow
                      placement="top"
                      enterTouchDelay={0}
                      slotProps={{
                        popper: {
                          sx: {
                            pointerEvents: 'none', 
                          },
                        },
                        tooltip: {
                          sx: {
                            backgroundColor: '#000', // Color de fondo personalizado
                            color: '#ffffff',           // Color del texto
                            fontSize: {sm: "8px", md:"10px", lg:"12px"},       // Tamaño de la fuente
                            padding: '8px 12px',        // Espaciado interno
                            borderRadius: '8px',        // Bordes redondeados
                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.5)', // Sombra
                          },
                        },
                        arrow: {
                          sx: {
                            color: '#1976d2', // Debe coincidir con el backgroundColor del tooltip
                          },
                        },
                      }}
                    >
                      <Chip
                        label={categoria}
                        sx={{
                          bgcolor: "#EAF9FF",
                          color: "#0B5E8E",
                          fontWeight: 600,
                          borderRadius: "10px",
                          border: "1px solid #C7EEFA",
                          transition: ".30s",
                          fontSize: {
                            xs: "9.5px",
                            sm: "8px",
                            lg: "8.3px",
                            xl: "10px",
                          },

                          "&:hover": {
                            bgcolor: "#06C7F9",
                            color: "#FFF",
                          },
                        }}
                      />
                    </Tooltip>
                  );
                })}
              </Stack>

              {/* Tarjeta informativa */}
              <CardMedia
                sx={{
                  bgcolor: "#F8FBFD",
                  border: "1px dashed #D8E4EC",
                  borderRadius: "14px",
                  mt: 1.5,
                  p: 1,
                  opacity: 1,
                  transition: ".30s",
                  ".MuiCard-root:hover &": {
                    opacity: 0,
                    transitionDelay: "0.2s"
                  },
              }}>
                <Typography
                  variant="subtitle2"
                  fontWeight={700}
                  color="primary"
                  textAlign="center"
                >
                  RESERVA UNA CITA
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  mt={0.5}
                  textAlign="center"
                  fontSize="11px"
                >
                  Comunicate a los siguientes numeros <br/>
                  Telefono {contenido.telefono} <br/>
                  WhatsApp {contenido.whatsapp}
                  
                </Typography>
              </CardMedia>
            </CardContent>

            <Divider sx={{ borderStyle: "dashed", borderColor: "#D8D8D8"}}/>

            {/* CEDULAS PROFESIONALES */}
            <CardContent sx={{ py: 1, px: 1.5}}>
              <Typography
                variant="overline"
                sx={{
                  color: "#06C7F9",
                  fontWeight: 700,
                  letterSpacing: 1.5,
              }}>
                {cedulas.length > 1 ? "CEDULAS PROFESIONALES" : "CEDULA PROFESIONAL"}
              </Typography>

              <Stack spacing={0.5} mt={0.5}>
                {cedulas.length > 0 ? (
                  cedulas.map((texto, index) => (
                    <Box key={index} display="flex" alignItems="center">
                      <Box
                        sx={{
                          width: 7,
                          height: 7,
                          borderRadius: "50%",
                          bgcolor: "#06C7F9",
                          mr: 1.5,
                          flexShrink: 0,
                      }}/>
                      <Button
                        variant="text"
                        onClick={() => abrirCedula(texto)}
                        sx={{
                          fontWeight:700,
                          color: "primary.deep",
                          minWidth:0,
                          textTransform:"none",
                          padding: "2px 6px",
                          fontSize: "10px",

                          '&:hover': {
                            bgcolor: "primary.deep",
                            color: "#FFF",
                          },
                        }}
                      >
                        Cédula: {texto}
                      </Button>
                    </Box>
                  ))
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    Información no disponible por el momento.
                  </Typography>
                )}
              </Stack>
            </CardContent>
          </Box>

          {/* IMAGEN (animacion) */}
          <CardMedia sx={{
            padding: "0",
            display: "flex",
            alignSelf: "center",
            opacity: 0,
            transition: "transform 1.1s ease, opacity 0.5s ease",
            position: "absolute",
            top: "0px",
            pointerEvents: "none",
            borderRadius: "50%",

            ".MuiCard-root:hover &": {
              transform: "translateY(-50px) rotateX(-25deg) translateZ(100px)",
              opacity: 1,
              transitionDelay: "0.4s",
              boxShadow: "0 25px 25px rgba(0,0,0,0.40)",
            },
          }}>
            <img
              src={contenido.imagen}
              alt="imagen-animacion"
              height="150px"
            />
          </CardMedia> 

          {/* Contenido (animacion) */}
          <CardContent sx={{
            borderRadius: "10px",
            height: "50px",
            padding: "0 !important",
            alignSelf: "center",
            opacity: 0,
            transition: "transform 1.1s ease, opacity 0.5s ease",
            position: "absolute",
            top: "335px",
            display: "flex",
            flexDirection: "row",
            border: "2px solid black",
  
            ".MuiCard-root:hover &": {
              transform: "translateY(0px) rotateX(-12deg) translateZ(80px)",
              opacity: 1,
              transitionDelay: "0.4s",
              boxShadow: "0 15px 15px rgba(0,0,0,0.40)",
            },
          }}>
            <Button
              component="a"
              href={"tel:"+contenido.numero}
              sx={{ 
                padding: "4px", 
                textDecoration: "none",
                borderRadius: "7px 0 0 7px",
                width:"60%",
                bgcolor:"primary.deep",
                transition: "all 0.5s ease",
                minWidth: "143px",
                "&:hover": {
                  bgcolor:"#ffffff",
                  "& .text1": {
                    color: "black",
                  },
                  "& .MuiSvgIcon-root": {
                    color: "black",
                  },
                }
            }}>
              <CallIcon sx={{ color: "white", width: "25px", paddingRight:"8px", transition: "all 0.7s ease" }} />
              <Typography className="text1" sx={{color: "white", fontSize: "10px", transition: "all 0.7s ease"}} >{contenido.telefono}</Typography>
            </Button>

            <Button
              component="a"
              href={"https://wa.me/"+contenido.whatsapp+"?text="+ encodeURIComponent(`¡Hola buen día! Me gustaría obtener más información sobre la atención médica de ${contenido.nombre}. ¿Podría brindarme información?`)}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ 
                padding: "4px", 
                textDecoration: "none",
                borderRadius: "0 7px 7px 0",
                borderLeft: "2px solid #fff",
                width:"40%",
                bgcolor:"primary.deep",
                transition: "all 0.5s ease",
                minWidth: "95px",
                "&:hover": {
                  bgcolor:"#ffffff",
                  "& .text2": {
                    color: "black",
                  },
                  "& .MuiSvgIcon-root": {
                    color: "black",
                  },
                }
            }}>
              <WhatsAppIcon sx={{color: "white", width: "25px", paddingLeft:"2px", paddingRight:"6px", transition: "all 0.7s ease"}} />
              <Typography className="text2" sx={{color: "white", fontSize: "10px", transition: "all 0.7s ease"}}>WHATSAPP</Typography>
            </Button>

            {/* <Button
              component="a"
              onClick={() => handleOpenModal(contenido.pdf)}
              sx={{ 
                padding: "8px", 
                textDecoration: "none",
                borderRadius: "0 10px 10px 0",
                borderLeft: "2px #000"
            }}>
              <InfoIcon sx={{ color: "white", width: "25px", }} />
              <Typography>CONOCEME</Typography>
            </Button> */}
          </CardContent>
        </Card>
        <ModalPDF
          open={openModal}
          handleClose={handleCloseModal}
          pdfOriginal={currentPdf}
        />
        <CedulaModal
          open={openCedula}
          onClose={() => setOpenCedula(false)}
          loading={loadingCedula}
          datos={datosCedula}
        />
      </Box>
    </Grid>
  );
};

export default memo(CardMedico);
